<div class="sms-container">
    <div class="sms-header">
        <div class="sms-header-row">
            <p class="date-header">
                <b>Date:</b>
                {{ smsDocument.originalDate | AvmDateAndTime }}
            </p>
        </div>
        <div class="sms-header-row">
            <p>
                <b>De:</b>
                {{ smsDocument.from?.replace(smsNumbersDelimiterRegex, '; ') }}
            </p>
        </div>
        <div class="sms-header-row">
            <p>
                <b>A:</b>
                {{ smsDocument.to?.replace(smsNumbersDelimiterRegex, '; ') }}
            </p>
        </div>
    </div>
    @if (displayPreview === true) {
        <iframe class="preview-iframe" [srcdoc]="content | byPassSecurity"></iframe>
    }
</div>
